import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M5.333 5.334V3.467c0-.747 0-1.12.145-1.405.128-.251.332-.455.583-.583.285-.146.659-.146 1.405-.146h5.067c.747 0 1.12 0 1.405.146.251.128.455.332.583.583.145.285.145.658.145 1.405v5.067c0 .746 0 1.12-.145 1.405-.128.25-.332.455-.583.582-.285.146-.658.146-1.405.146h-1.867m-7.2 4h5.067c.747 0 1.12 0 1.405-.146.251-.127.455-.331.583-.582.145-.285.145-.659.145-1.405V7.467c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.146-.658-.146-1.405-.146H3.466c-.746 0-1.12 0-1.405.146a1.34 1.34 0 0 0-.583.583c-.145.285-.145.658-.145 1.405v5.067c0 .746 0 1.12.145 1.405.128.25.332.455.583.582.285.146.659.146 1.405.146"
    }, null, -1)
  ])))
}
export default { render: render }